var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.friendType)?_c('div',{staticClass:"badge-friend-type badge badge-brd",class:{
        recommended: _vm.friendType === 'recommended',
        normal: _vm.friendType === 'normal',
        'premium-badge': _vm.isPremium,
    },domProps:{"innerHTML":_vm._s(_vm.$translate(_vm.friendTypeLabel))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }